
import { AppIntroScreenNavigationProps } from "./types"
import React from "react"
import AppIntro from "./app-intro-screen"
import { PageRoot } from "~screens/page-root"


const AppIntroScreen: React.FC<AppIntroScreenNavigationProps> = () => {
  return (
    <PageRoot $background="white">
      <AppIntro />
    </PageRoot>
  )
}

export default AppIntroScreen
